import { alpha, makeStyles, Tooltip } from '@material-ui/core';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';

const ICON_SIZE = 20;

const useStyles = makeStyles(({ palette }) => ({
  root: {
    position: 'relative',
    width: ICON_SIZE,
    height: ICON_SIZE,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: palette.primary.main,
    cursor: 'default',
    flexShrink: 0,
  },

  icon: {
    position: 'relative',
    zIndex: 3,
    fontSize: ICON_SIZE,
    backgroundColor: alpha(palette.background.paper, 1),
    borderRadius: '50%',
  },

  wave: {
    position: 'absolute',
    inset: 0,
    borderRadius: '50%',
    backgroundColor: alpha(palette.primary.main, 1),
    animation: '$sonar 2.2s infinite',
    pointerEvents: 'none',
  },

  wave2: {
    animationDelay: '0.7s',
  },

  wave3: {
    animationDelay: '1.4s',
  },

  '@keyframes sonar': {
    '0%': {
      transform: 'scale(0.45)',
      opacity: 0.65,
    },
    '70%': {
      opacity: 0.15,
    },
    '100%': {
      transform: 'scale(2)',
      opacity: 0,
    },
  },
}));

export default function IncomingTransferIndicator() {
  const classes = useStyles();

  return (
    <Tooltip title="Transferência recebida" arrow>
      <div className={classes.root}>
        <span className={classes.wave} />
        <span className={`${classes.wave} ${classes.wave2}`} />
        <span className={`${classes.wave} ${classes.wave3}`} />

        <SwapHorizIcon className={classes.icon} />
      </div>
    </Tooltip>
  );
}
